'use client'

import { UserManual, mapLanguageAndLocale } from '@/lib/digital-twin'
import { ProductResourcesUserManualsTranslationsFragment } from './ProductResourcesUserManuals.generated'
import ProductResourcesCard, {
	ResourceType,
} from '../ProductResourcesCard/ProductResourcesCard'
import { useParams } from 'next/navigation'
import { LanguageRecord } from '@/graphql/types'
import { localeToDatoLocale } from '@/lib/locale.utils'
import ProductResourcesCardContainer from '../ProductResourcesCard/ProductResourcesCardContainer'
import ProductResourcesCardContainerHeader from '../ProductResourcesCard/ProductResourcesCardContainerHeader'

type ProductResourcesUserManualsProps = {
	translations: ProductResourcesUserManualsTranslationsFragment
	userManuals: {
		'@odata.context': string
		'@odata.count': number
		value: UserManual[]
	}
}

export default function ProductResourcesUserManuals({
	translations,
	userManuals,
}: ProductResourcesUserManualsProps) {
	const { lang } = useParams()
	const datoLocale = localeToDatoLocale(lang as string)

	const userManualsToShow = userManuals.value.filter(
		(userManual) =>
			mapLanguageAndLocale[datoLocale]?.includes(userManual.item_language) ||
			userManual.item_language === 'Multi',
	)

	return userManualsToShow.length > 0 ? (
		<div className="mb-10">
			<h3 className="text-md font-bold">{translations.userManuals}</h3>
			<ProductResourcesCardContainerHeader>
				<div className="flex-1"></div>
				<div className="w-8"></div>
				<div className="w-16 text-center">{translations.resourceVersion}</div>
				<div className="w-12 text-center">{translations.resourceSize}</div>
				<div className="w-10 ms-8"></div>
			</ProductResourcesCardContainerHeader>
			<ProductResourcesCardContainer>
				{userManualsToShow.map((userManual) => (
					<ProductResourcesCard
						key={userManual.key}
						translations={translations as LanguageRecord}
						title={userManual.metadata_storage_name}
						description={userManual.item_description}
						column4={userManual.item_version}
						documentSize={userManual.metadata_storage_size}
						resourceType={ResourceType.Document}
						document={userManual}
					/>
				))}
			</ProductResourcesCardContainer>
		</div>
	) : null
}
